import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { Box, Button, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { redirectToPasswordReset } from "@entrilia/shared/auth/b2c/redirects";
import LoaderBox from "@entrilia/shared/components/LoaderBox";
import useClientPageTitle from "../../../../contexts/useClientPageTitle";
import {
  identitySignInEmailSelector,
  impersonationSelector,
  loadingIdentitySelector,
} from "../../../../store/state/user/selectors";

export const PasswordAuth = () => {
  useClientPageTitle("Authentication");

  const signInEmail = useSelector(identitySignInEmailSelector);
  const isImpersonation = useSelector(impersonationSelector);

  return (
    <LoaderBox loading={useSelector(loadingIdentitySelector)}>
      <Box sx={{ py: "1.5rem", px: "2rem", width: "100%" }}>
        <Typography variant="h5" sx={{ mb: "1rem" }}>
          Password & Authentication
        </Typography>
        <Box sx={{ display: "flex", flexDirection: "column" }}>
          <Typography variant="subtitle1" sx={{ lineHeight: "24px", py: "0.5rem" }}>
            Password
          </Typography>
          <Typography color="textSecondary" sx={{ lineHeight: "24px" }}>
            This password is used for login to your account.
          </Typography>

          <Button
            variant="outlined"
            sx={{ width: "10rem", mt: "1.4rem" }}
            onClick={redirectToPasswordReset}
            disabled={isImpersonation}
          >
            Change password
          </Button>

          <Typography variant="subtitle1" sx={{ lineHeight: "24px", pt: "2rem", pb: "1rem" }}>
            2FA Authentication
          </Typography>

          <Box
            sx={(theme) => ({
              display: "flex",
              gap: "1rem",
              padding: "1rem",
              width: "70%",
              maxWidth: "650px",
              backgroundColor: theme.palette.background.grey,
              borderRadius: "4px",
              color: theme.palette.text.primary,
            })}
          >
            <EmailRoundedIcon fontSize="large" color="secondary" />
            <Box sx={{ display: "flex", flexDirection: "column", gap: ".2rem" }}>
              <Typography variant="subtitle1">Email</Typography>
              <Typography color="textSecondary">Confirmation codes are sent to the email specified earlier</Typography>
              <Typography>{signInEmail}</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </LoaderBox>
  );
};

export default PasswordAuth;
